module.exports = __webpack_public_path__ + "img/down-arrow.ca40f1ab.svg";